import { authClient } from "@/lib/auth-client";
import { Navigate, useLocation } from "react-router-dom";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const location = useLocation();
	const { data: session, isPending } = authClient.useSession();

	if (!isPending && !session)
		return <Navigate to="/sign-in" state={{ from: location }} replace />;

	return children;
}
